import get from 'lodash/get';

export const isStarred = (profile, conversationId) => !!get(profile, 'conversations', [])
  .find(j => conversationId === j.id);

export const setConversationReviewed = ({ aiq, conversationId, store }) => {
  aiq.confirm(
    'Mark as reviewed',
    'This action will remove the conversation from the list',
  )
    .then(confirm => {
      if (confirm) {
        store.dispatch('conversations/closeConversation', conversationId)
          .then(() => {
            aiq.notify.info('Conversation is marked as reviewed.');
          });
      }
    }, () => {});
};
